
export class ItemViewModel {
  constructor(id?: number, name?: string) {
    this.Id = id;
    this.Name = name;
  }

  public Id: number;
  public Name: string;
}
export class StringItemViewModel {
  constructor(id?: string, name?: string) {
    this.Id = id;
    this.Name = name;
  }

  public Id: string;
  public Name: string;
}

export class DuePaymentsViewModel {

  public Id: number;
  public FK_Client: ItemViewModel;
  public FK_Account: ItemViewModel;
  public FK_Payment: ItemViewModel;
  public FK_Sale: ItemViewModel;
  public FK_Purchase: ItemViewModel;
  public FK_VehicleRent: ItemViewModel;
  public FK_RentInvoice: ItemViewModel;
  public FK_EmployeeCommission: ItemViewModel;
  public FK_DHCommission: ItemViewModel;
  public FK_DHNCommission: ItemViewModel;
  public FK_TalabatSalary: ItemViewModel;
  public FK_DeliveroCommission: ItemViewModel;
  public FK_EmployeePerDaySalary: ItemViewModel;
  public FK_SimExpense: ItemViewModel;
  public FK_GeneralExpense: ItemViewModel;
  public FK_TrafficExpense: ItemViewModel;
  public Type: string;
  public SourceTable: string;
  public InvoiceNumber: string;
  public Amount: number;
  public Balance: number;
  public CreatedDate: Date;
  public UpdatedDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
  public RecordStatus: boolean;
  public Payment: number;
  public Source: string;
  public NetAmount: number;
  public RemainingAmount: number;
  public FK_PaymentMaster_Id: number;
  public Mode: string;
}

export class PaymentInstallmentViewModel {

  public Id: number;
  public DId: number;
  public FK_Account: ItemViewModel;
  public FK_Sale: ItemViewModel;
  public FK_Purchase: ItemViewModel;
  public FK_VehicleRent: ItemViewModel;
  public FK_RentInvoice: ItemViewModel;
  public FK_EmployeeCommission: ItemViewModel;
  public FK_DHCommission: ItemViewModel;
  public FK_DHNCommission: ItemViewModel;
  public FK_TalabatSalary: ItemViewModel;
  public FK_DeliveroCommission: ItemViewModel;
  public FK_EmployeePerDaySalary: ItemViewModel;
  public FK_SimExpense: ItemViewModel;
  public FK_GeneralExpense: ItemViewModel;
  public FK_TrafficExpense: ItemViewModel;
  public Type: string;
  public InvoiceNumber: string;

  public CreatedDate: Date;
  public UpdatedDate: Date;
  public Source: string;
  public TotalAmount: number;
  public PaidAmount: number;
  public RemainingAmount: number;
  public FK_PaymentDue_Id: number;
  public FK_OffsetMaster_Id: number;
  public FK_PaymentMaster_Id: number;

}


export class PaymentMasterViewModel {

  public Id: number;
  public FK_Account: ItemViewModel;
  public FK_Client: ItemViewModel;
  public Type: string;
  public Amount: number;
  public Balance: number;
  public CreatedDate: Date;
  public UpdatedDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
  public TransactionDate: Date;
  public Remarks: string;
  public FK_PaymentDue_Id: number;
  public Mode: string;
}


export class OffsetMasterViewModel {

  public Id: number;
  public FK_Account: ItemViewModel;
  public FK_Client: ItemViewModel;
  public Type: string;
  public Amount: number;
  public CreatedDate: Date;
  public UpdatedDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
  public FK_PaymentDue_Id: number;
  public FK_OffsetMaster_Id: number;
  public FK_PaymentMaster_Id: number;
  public TotalAmount: number;
}